<template>
	<div class="col-md-offset-1 col-md-6 col-xs-12 col-sm-12 row" id="result" hidden>
		<div class="col-md-12">
			<div class="row">
				<span>Total facturé</span>
				<span class="pull-right">{{revenue}} €</span>
			</div>
			<div class="row profit-expense">
				<div class="col-md-6 col-xs-12 col-sm-12 expense">
					<div class="row billingInfo">
						<span>Débours</span>
						<span class="pull-right">{{debours}} €</span>
					</div>
					<div v-show="info.taxEnable!=0" class="row" style="background-color: #c9857085;">
						<span>TVA</span>
						<span class="pull-right">{{tva}} €</span>
					</div>
					<div v-show="info.sejour_tax!=0" class="row" style="background-color: #c9857085;">
						<span>Taxe de séjour</span>
						<span class="pull-right">{{sejour_tax}} €</span>
					</div>
					<div v-show="!isSolo" class="row" style="background-color: #e3917985;">
						<span>Honoraires</span>
						<span class="pull-right">{{honoraires}} €</span>
					</div>
				</div>
				<div class="col-md-6 col-xs-12 col-sm-12 profit">
					<!--<div class="row" style="background-color: #468b5c85;">
						<span>Recettes Brutes</span>
						<span class="pull-right">{{ca}} €</span>
					</div>-->
					<div class="row" style="background-color: #6cb18285;">
						<span>Recettes Nettes</span>
						<span v-show="isSolo || info.taxEnable==0" class="pull-right">{{netRevenue}} €</span>
					</div>
					<div v-show="!isSolo && info.taxEnable!=0" class="row" style="background-color: #6cb18285;"><span></span>
						<span class="pull-right">{{netRevenue}} €</span>
					</div>
				</div>
			</div>
			<span id="table-footer">
				<div class="row">
					<span>Frais Pro {{info.taxEnable==0?"":"(HT)"}}</span>
					<span class="pull-right">{{proExp}} €</span>
				</div>
				<div v-show="info.taxEnable!=0" class="row">
					<span>TVA Frais Pro</span>
					<span class="pull-right">{{proExpTva}} €</span>
				</div>
			</span>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'bilanData',
		props: {
			info : Object,
		},
		data () {
			return {
				startDate: "",
				endDate: "",
				revenue:0,
				proExp:0,
				proExpTva:0,
				debours:0,
				ca:0,
				honoraires : 0,
				gains: 0,
				tva: 0,
				isSolo:false,
				netRevenue:0,
				sejour_tax:0,
				errors: []
			}
		},
		methods: {
			show:function(){
				this.$nextTick(() => {//wait for this.info to update
					let toFormat = ["ca","debours","gains","honoraires","proExp","proExpTva","revenue","tva","sejour_tax"]
					let formatConfig  = {'minimumFractionDigits':2,'maximumFractionDigits':2}
					for (let key of toFormat) {
					  this[key]=parseFloat(this.info[key]).toLocaleString(undefined,formatConfig)
					}
					this.netRevenue=(this.info.gains-this.info.tva-this.info.sejour_tax).toLocaleString(undefined,formatConfig)
					this.isSolo = this.info.isSolo
					$("#result").slideDown("slow")
					Chart.helpers.each(Chart.instances, function(instance){//destroy old graph
						if(instance.chart.canvas.id=="graphCustomers"||instance.chart.canvas.id=="graphHonoraire"){
							instance.destroy();
						}
					})
					let customXLabel=function(label, index, labels) {
						const reducer = (accumulator, currentValue) => accumulator + currentValue;
						let sum = this.chart.config.data.datasets[0].data.reduce(reducer);
						let percent = this.chart.config.data.datasets[0].data[index]/sum;
						return (percent*100).toFixed(2)+' %';
					}
					//TODO: Switch to ChartHelper.php
					let revenuePerCustomerChart = new ChartHelper("bar",this.info.revenuePerCustomer[0],"","","€",0,false,true,false,false,false,true,false,customXLabel,"","CLIENTS");
					let colors=[]
					colors[7]=[0,0,0];//colonne autre => noir
					revenuePerCustomerChart.addDataset("",this.info.revenuePerCustomer[1],true,colors,0);
					revenuePerCustomerChart.getChart($('#graphCustomers'))

					if(!$("#customerChart").is(":visible")){
						$("#graphCustomers").animate({
							height: 300
						},'slow');
					}else{$("#graphCustomers").height(300)}
					$("#customerChart").show()
					if(!this.isSolo){
						let honoraireByUserChart = new ChartHelper("bar",this.info.honoraireByUser[0],"","","€",2,false,true,false,false,false,true,false,"","","HONORAIRES PERMANENTS");
						honoraireByUserChart.addDataset("",this.info.honoraireByUser[1],true,[],0);
						honoraireByUserChart.getChart($('#graphHonoraire'))

						if(!$("#honoraireChart").is(":visible")){
							$("#graphHonoraire").animate({
								height: 300
							},'slow');
						}else{$("#graphHonoraire").height(300)}
						$("#honoraireChart").show()
					}
				})
			}
		}
	}
</script>
<style type="text/css" scoped>
	#result>div{
		box-shadow: 7px 9px 28px 1px rgba(0,0,0,0.15);
	}
	#result>div>div:first-child{
		background-color: transparent;
        display: flex;
        align-items: center;
        padding: 0;
        border-top-right-radius: 3px!important;
        border-top-left-radius: 3px!important;
        font-weight: bold;
        font-size: 19px;
        border-bottom: 1px solid #EFEFEF;
	}
	#result>div>div:first-child>span{
		color: #555
	}
	#result>div>div:first-child>span:last-child{
		text-align: right;
		flex-grow: 1;
		font-weight: bold;
	}
	.profit-expense>div>div{
		padding: 1em;
		display: flex;
		align-items: center;
	}
	.profit-expense>div>div>span{
		color: #555;
	}
	.profit-expense>div>div span:last-child{
		text-align: right;
		flex-grow: 1;
		font-weight: bold;
	}
	#table-footer>div{
		padding: 1em;
		display: flex;
		align-items: center;
	}
	#table-footer>div span:last-child{
		text-align: right;
		flex-grow: 1;
		color: #fff;
		font-weight: bold;
	}
	#table-footer>div:first-child{
		background-color: #777777;
		color: #fff;
	}
	#table-footer>div:last-child{
		background-color: #c9857085;
		color: #555;
		border-bottom-right-radius: 3px!important;
		border-bottom-left-radius: 3px!important;
	}
    
    .profit-expense>div>div[data-v-49220b21] {
    padding: 1em 0;
    display: flex;
    align-items: center;
}
</style>
